import type { Referral } from '../../shared/types';
import { formatPhone, mapsHref, telHref } from '../lib/format';

export function CustomerCard({ referral }: { referral: Referral }) {
  return (
    <div className="card">
      <h2 style={{ marginBottom: '0.25rem' }}>{referral.customerName}</h2>
      <p className="muted" style={{ margin: 0 }}>
        {referral.refNumber}
      </p>
      <div className="stack" style={{ marginTop: '0.75rem' }}>
        <a href={telHref(referral.customerPhone)} style={{ display: 'block', fontWeight: 600 }}>
          {formatPhone(referral.customerPhone)}
        </a>
        <a href={mapsHref(referral.customerAddress)} target="_blank" rel="noreferrer">
          {referral.customerAddress}
        </a>
        {referral.customerEmail && <a href={`mailto:${referral.customerEmail}`}>{referral.customerEmail}</a>}
      </div>
      <p style={{ marginTop: '0.75rem', whiteSpace: 'pre-wrap' }}>{referral.jobDescription}</p>
    </div>
  );
}
